export const API_URL =
    process.env.NODE_ENV === "production"
        ? "https://kt-api.taitur.net"
        : "http://localhost:8010/proxy";
